import formatNum from '@/filters/formatNum';

/**
 * Format percent like 3,000.13%
 */
function formatPercent(value: number = 0, digits: number = 2): string {
    return formatNum(value, digits) + '%';
}

export default formatPercent;
